import React from "react";

import Page from "../../Components/Page";
import AddShiftForm from "./Dashboard/AddShiftForm";

/**
 * AddShiftHelix component.
 *
 * @returns {JSX.Element}
 * @constructor
 *
 * @description Provides a messaging interface for employees to notify the office of shift pickups.
 */
const AddShiftHelix = () => {
    return (
        <Page
            hideHeader
        >
            <AddShiftForm helix/>
        </Page>
    );
};

export default AddShiftHelix;